import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=6489d0fe&scoped=true&"
import script from "./NewUser.vue?vue&type=script&lang=js&"
export * from "./NewUser.vue?vue&type=script&lang=js&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=6489d0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489d0fe",
  null
  
)

export default component.exports